import moment from 'moment';
import 'moment-timezone';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import LocaleFormat from '../utils/LocaleFormat.js'

// Date display formats that should be replaced with locale-aware 'L' or 'L LT'
var DATE_ONLY_FORMATS = ['DD/MM/YYYY', 'DD-MM-YYYY', 'L'];
var DATETIME_FORMATS = ['DD/MM/YYYY HH:mm', 'DD-MM-YYYY HH:mm'];

class Timezone {
	static getDateForClient(data, format) {
		if(!data)
			return data;
		var dataMoment = moment.tz(data, "America/Argentina/Buenos_Aires");
		let timezoneDefault = ConfigBusiness.get('frontend.timezoneDefault');
		if(format)
			return dataMoment.tz(timezoneDefault).format(format);
		else 
			return dataMoment.tz(timezoneDefault);
	}

	static getDateForServer(data) {
		if(!data)
			return data;
		var dataMoment = moment(data).tz('America/Argentina/Buenos_Aires');
		return dataMoment;
	}

	static getDateForClient(data, formatIn, formatOut) {
		if(!data)
			return data;
		if (data === 'now')
			data = moment().tz("America/Argentina/Buenos_Aires");
		if(formatIn)
			data = moment(data, formatIn).format('YYYY-MM-DD HH:mm:ss');
		var dataMoment = moment.tz(data, "America/Argentina/Buenos_Aires");
		let timezoneDefault = ConfigBusiness.get('frontend.timezoneDefault');
		if(formatOut) {
			if (DATE_ONLY_FORMATS.indexOf(formatOut) !== -1) {
				return LocaleFormat.formatDate(dataMoment.tz(timezoneDefault));
			}
			if (DATETIME_FORMATS.indexOf(formatOut) !== -1) {
				return LocaleFormat.formatDateTime(dataMoment.tz(timezoneDefault));
			}
			return dataMoment.tz(timezoneDefault).format(formatOut);
		} else {
			return dataMoment.tz(timezoneDefault);
		}
	}
}

export default Timezone;